/** Type safe way to retrieve a value from a `Record<string, unknown>` type object*/
export const safeRetrieveValue = function <T>(
  settings: Record<string, unknown>,
  key: string,
  checker: (x: unknown, key: string) => x is T
): T | null {
  if (settings && key in settings) {
    const value = settings[key];
    if (key in settings && checker(value, key)) {
      return value;
    }
  }

  return null;
};
